import { useCallback } from 'react';
import { useState, useEffect, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { toastify } from "../../components/Toast";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { Trash2, DownloadIcon, CopyIcon, ImageIcon, PenTool, Save, Loader } from "lucide-react";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import ConfirmModal from "../Modals/ConfirmModal";
import services from "../../API";
import ImageEditComponent from "./ImageEditComponent";
import React from "react";
import { CircularLoader } from "../Loader/CircularLoader";
import RichDescription from "../RichDescription/RichDescription";

function extractReferenceText(html) {
  if (!html) return "";
  const documentNode = new DOMParser().parseFromString(html, "text/html");
  return documentNode.body?.textContent?.trim() || "";
}
const AdDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  useState(false);
  const [ad, setAd] = useState("");
  let [isOpens, setIsOpen] = useState(false);
  let [isOpensDelete, setIsOpenDelete] = useState(false);
  const [selectedVariant, setSelectedVariant] = useState(0);
  const [selectedImageVariation, setSelectedImageVariation] = useState("");
  const [activeTab, setActiveTab] = useState("image");
  const [editableHeadline, setEditableHeadline] = useState("");
  const [editableCopy, setEditableCopy] = useState("");
  const [, setEditableCopyHeadline] = useState("");
  const [isGeneratingVariants, setIsGeneratingVariants] = useState(false);
  useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [isTextExpanded, setIsTextExpanded] = useState(false);
  const [isDeleteMode, setIsDeleteMode] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const [showOriginalReference, setShowOriginalReference] = useState(false);
  const [selectedCopyVariation, setSelectedCopyVariation] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [, setLoading] = useState(true);
  const [, setError] = useState("");
  const [isAdNotFound, setIsAdNotFound] = useState(false);
  const [updateAds, setUpdateAds] = useState(false);
  const [hasImage, setHasImage] = useState("");
  const [referenceCard, setReferenceCard] = useState("");
  const [variationsAdCopy, setVariationAdCopy] = useState([]);
  const [variationsAdCopyData, setVariationsAdCopyData] = useState("");
  const [, setStatusCopyContent] = useState(false);
  const [, setCopyOriginalContent] = useState("");
  // Add this state variable with your existing state
  const [isReferenceExpanded, setIsReferenceExpanded] = useState(false);
  // 1. Add this state variable with your existing state variables
  const [isDownloading, setIsDownloading] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [adCopyPrompt, setAdCopyPrompt] = useState("");
  const [, setOriginalDescription] = useState("");

  // Add new state variables for image tab functionality
  const [selectedVariations, setSelectedVariations] = useState([]);
  const [hoveredVariation, setHoveredVariation] = useState(null);
  useState("");
  useState([]);
  const [, setIsDropdownOpen] = useState(false);
  const [, setSelectedAspectRatio] = useState();

  // Add state variables for copy variations functionality
  const [selectedCopyVariations, setSelectedCopyVariations] = useState([]);
  const [hoveredCopyVariation, setHoveredCopyVariation] = useState(null);
  const [isCopyDeleteMode, setIsCopyDeleteMode] = useState(false);
  const [isDeletingVariants, setIsDeletingVariants] = useState(false);
  const [adCopyWarning, setAdCopyWarning] = useState(false);
  const [adCopyWarningMessage, setAdCopyWarningMessage] = useState("");
  const [showUnsavedChangesForGeneration, setShowUnsavedChangesForGeneration] =
    useState(true);
  const [selectedAdCopyId, setSelectedAdCopyId] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);



  // Aspect ratio icon component


  // Handle variation selection
  const handleVariationSelection = (variantId) => {
    setSelectedVariations((prev) => {
      if (prev.includes(variantId)) {
        return prev.filter((id) => id !== variantId);
      } else {
        return [...prev, variantId];
      }
    });
  };

  // Handle copy variation selection
  const handleCopyVariationSelection = (variantId) => {
    setSelectedCopyVariations((prev) => {
      if (prev.includes(variantId)) {
        return prev.filter((id) => id !== variantId);
      } else {
        return [...prev, variantId];
      }
    });
  };

  // Handle reference image upload


  // Handle aspect ratio change


  // Copy original description to clipboard




  const getImageUrl = (variation) => {
    if (typeof variation === "string") return variation;
    return variation?.url || "";
  };

  const waitForImageToLoad = (url, attempts = 1) =>
    new Promise((resolve) => {
      if (!url) {
        resolve(false);
        return;
      }

      let remainingAttempts = attempts;
      const tryLoad = () => {
        const image = new Image();
        image.onload = () => resolve(true);
        image.onerror = () => {
          remainingAttempts -= 1;
          if (remainingAttempts === 0) {
            resolve(false);
            return;
          }
          window.setTimeout(tryLoad, 1500);
        };
        image.src = url;
      };

      tryLoad();
    });

  const fetchAdDetail = useCallback(async () => {
    const token = localStorage.getItem("token");
    setLoading(true);
    setError("");
    setIsAdNotFound(false);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}ads/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the request header
          },
        }
      );
      const coverImageFound = response?.data?.data?.imageVariations?.find(
        (variation) => variation?.url === response?.data?.data?.imageUrl
      );

      const adDetail = {
        id: response.data.data._id,
        brandId: response.data.data.brandId ? response.data.data.brandId : "",
        title: response.data.data.userPrompt,
        headline: response.data.data.headline,
        description: response.data.data.description,
        copy: response.data.data.adCopyText,
        size: coverImageFound?.size,
        // aspectRatio:
        //   response.data.data.size == "1024x1024"
        //     ? "1:1"
        //     : response.data.data.size == "1024x1536"
        //     ? "9:16"
        //     : "16:9",
        aspectRatio: coverImageFound?.size,
        brand: response.data.data.brandId
          ? response.data.data.brandId.brandName
          : "Zimzee",
        variants: response.data.data.imageVariations,
        visualKeywords: response.data.data.visualKeywords,
        imageUrl: response.data.data.imageUrl,
        createdAt: response.data.data.createdAt,
        performance: { likes: 42, comments: 69, shares: 42 },
        selectedCopyVariationId: response?.data?.data?.selectedCopyVariation,
        imageVariationInProgress:
          response?.data?.data?.imageVariationInProgress,
      };
      const hasImag = adDetail.imageUrl && adDetail.imageUrl.trim() !== "";
      setHasImage(hasImag);
      setEditableCopy(response.data.data.adCopyText);
      setCopyOriginalContent(response.data.data.adCopyText);
      setEditableHeadline(response.data.data.headline);
      setOriginalDescription(response.data.data.userPrompt);
      const adCopyIndex = response?.data?.data?.adCopyVariations?.findIndex(
        (ad) => ad?._id === response?.data?.data?.selectedCopyVariation
      );
      if (adCopyIndex === -1) {
        setSelectedCopyVariation(0);
      } else {
        setSelectedCopyVariation(adCopyIndex);
      }
      setSelectedAspectRatio(coverImageFound?.size);
      const index = adDetail?.variants.findIndex(
        (url) => url?.url?.split("?")[0] === adDetail?.imageUrl.split("?")[0]
      );
      setSelectedImageVariation(adDetail?.imageUrl);
      setSelectedVariant(index);
      setVariationAdCopy(response.data.data.adCopyVariations || []);

      setAd(adDetail);
      if (response.data.data.refrenceCardId) {
        await axios
          .get(
            `${process.env.REACT_APP_API}cards/single-card/${response.data.data.refrenceCardId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then(function (response) {
            setIsLoading(false);
            setReferenceCard(response.data.data);
          })
          .catch(function (error) {
            console.error(error);
          });
      }
      // setAudience(audience);
      return adDetail;
    } catch (err) {
      console.error(err);
      setIsLoading(false);
      if (err.response?.status === 404) {
        setIsAdNotFound(true);
      } else {
        setError("Failed to load ads. Please try again.");
      }
    } finally {
      setIsLoading(false);
      setLoading(false);
    }
  }, [id]);
  useEffect(() => {
    fetchAdDetail();
  }, [updateAds, fetchAdDetail]);

  useEffect(() => {
    setHasUnsavedChanges(
      editableCopy !== ad.copy || editableHeadline !== ad.headline
      // ||
      // selectedImageVariation !== ad.imageUrl
    );
    setIsTextExpanded(false);
  }, [
    editableCopy,
    editableHeadline,
    ad.copy,
    ad.headline,
    // selectedImageVariation,
  ]);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
      // Close size dropdown when clicking outside
      if (!event.target.closest(".size-dropdown")) {
        setIsDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const fetchAdVariations = async (previousVariationUrls = []) => {
    const token = localStorage.getItem("token");
    setLoading(true);
    setError("");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}ads/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the request header
          },
        }
      );

      const imageVariations = response?.data?.data?.imageVariations || [];
      const latestVariation = imageVariations[imageVariations.length - 1];
      const latestImageUrl = getImageUrl(latestVariation);
      const hasNewVariation =
        previousVariationUrls.length === 0 ||
        !previousVariationUrls.includes(latestImageUrl);
      const coverImageFound = imageVariations.find(
        (variation) => variation?.url === response.data.data.imageUrl
      );
      const adDetail = {
        id: response.data.data._id,
        brandId: response.data.data.brandId ? response.data.data.brandId : "",
        title: response.data.data.userPrompt,
        headline: response.data.data.headline,
        description: response.data.data.description,
        copy: response.data.data.adCopyText,
        size: coverImageFound?.size,
        aspectRatio: coverImageFound?.size,
        brand: response.data.data.brandId
          ? response.data.data.brandId.brandName
          : "Zimzee",
        variants: imageVariations,
        visualKeywords: response.data.data.visualKeywords,
        imageUrl: response.data.data.imageUrl,
        createdAt: response.data.data.createdAt,
        performance: { likes: 42, comments: 69, shares: 42 },
        imageVariationInProgress:
          response?.data?.data?.imageVariationInProgress,
      };
      const hasImag = adDetail.imageUrl && adDetail.imageUrl.trim() !== "";
      setHasImage(hasImag);
      setEditableCopy(response.data.data.adCopyText);
      setCopyOriginalContent(response.data.data.adCopyText);
      setEditableHeadline(response.data.data.headline);
      setOriginalDescription(response.data.data.userPrompt);
      setVariationAdCopy(response.data.data.adCopyVariations || []);

      // A variation record can be returned before its storage/CDN asset is
      // available. Keep showing the current image until the new one loads.
      if (hasNewVariation && latestImageUrl) {
        const imageIsReady = await waitForImageToLoad(latestImageUrl);
        if (imageIsReady) {
          setSelectedImageVariation(latestImageUrl);
          setSelectedVariant(imageVariations.length - 1);
          setAd(adDetail);
          handleSaveChanges(false, latestImageUrl);
          return {
            imageVariationInProgress: adDetail.imageVariationInProgress,
            hasNewVariation,
            imageIsReady,
          };
        }

        return {
          imageVariationInProgress: adDetail.imageVariationInProgress,
          hasNewVariation,
          imageIsReady,
        };
      }

      setAd(adDetail);
      return {
        imageVariationInProgress: adDetail.imageVariationInProgress,
        hasNewVariation,
        imageIsReady: Boolean(latestImageUrl),
      };
    } catch (err) {
      setIsLoading(false);
      setError("Failed to load ads. Please try again.");
      return { imageVariationInProgress: false, hasNewVariation: false };
    } finally {
      setIsLoading(false);
      setLoading(false);
    }
  };

  function closeModal() {
    setIsOpen(false);
  }
  function closeModalDelete() {
    setIsOpenDelete(false);
  }

  const saveEditedChanges = async (saveOnlyAdCopy = true, imageURL) => {
    const token = localStorage.getItem("token");
    let payload = {};

    if (saveOnlyAdCopy) {
      payload.adCopyText = editableCopy;
      payload.headline = editableHeadline;
      payload.adCopyVariations = variationsAdCopy;
      payload.selectedCopyVariation = selectedAdCopyId;
    }
    if (imageURL) {
      payload.imageUrl = imageURL;
    }

    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_API}ads/${id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!imageURL) {
        toastify("success", response.data.message);
      }
      setUpdateAds(!updateAds);
      setHasUnsavedChanges(false);
    } catch (err) {
      setError("Failed to save brand. Please try again.");
      toastify("error", err.response.data.message);
      console.error(err);
    }
  };

  const handleSaveChanges = async (
    saveOnlyAdCopy = true,
    imageURL,
    editableCopy,
    editableHeadline,
    adCopyId
  ) => {
    const token = localStorage.getItem("token");
    let payload = {};

    if (saveOnlyAdCopy) {
      payload.adCopyText = editableCopy;
      payload.headline = editableHeadline;
      payload.selectedCopyVariation = adCopyId;
    }

    if (imageURL) {
      payload.imageUrl = imageURL;
    }

    try {
      await axios.patch(
        `${process.env.REACT_APP_API}ads/${id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setUpdateAds(!updateAds);
      setHasUnsavedChanges(false);
    } catch (err) {
      setError("Failed to save brand. Please try again.");
      toastify("error", err.response.data.message);
      console.error(err);
    }
  };

  const handleSelectedCopyVariation = (variantionIndex, adCopyId) => {
    setSelectedAdCopyId(adCopyId);
    setShowUnsavedChangesForGeneration(false);
    setSelectedCopyVariation(variantionIndex);
    const filtered = variationsAdCopy.filter((_, i) => i === variantionIndex);
    setVariationsAdCopyData(filtered[0]);
    setEditableHeadline(filtered[0].headline);
    setEditableCopyHeadline(filtered[0].headline);
    setEditableCopy(filtered[0].copy);
    handleSaveChanges(
      true,
      "",
      filtered[0].copy,
      filtered[0].headline,
      adCopyId
    );
  };

  const handleGenerateCopyVariants = async () => {
    setIsGeneratingVariants(true);
    setShowUnsavedChangesForGeneration(false);
    const token = localStorage.getItem("token");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}ads/adCopy/variations`,
        { adId: id, userPrompt: adCopyPrompt },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the request header
          },
        }
      );
      toastify("success", response.data.message);

      setVariationAdCopy(response.data.data.variations || []);
      const adCopy =
        response.data.data.variations[response.data.data.variations.length - 1];

      setSelectedCopyVariation(response.data.data.variations.length - 1);
      setVariationsAdCopyData(adCopy);
      setEditableHeadline(adCopy.headline);
      setEditableCopyHeadline(adCopy.headline);
      setEditableCopy(adCopy.copy);
      handleSaveChanges(true, "", adCopy.copy, adCopy.headline, adCopy._id);
      setIsGeneratingVariants(false);
    } catch (err) {
      setError("Failed to save brand. Please try again.");
      toastify("error", err.response.data.message);
      console.error(err);
    }
  };



  const handleCopyCopyVariations = async () => {
    if (selectedCopyVariations.length === 0) return;

    try {
      const selectedVariants = selectedCopyVariations.map(
        (index) => variationsAdCopy[index]
      );
      const textContent = selectedVariants
        .map(
          (variant, i) =>
            `Variation ${i + 1}:\nHeadline: ${variant.headline}\nDescription: ${variant.description ?? ""
            }\nCopy: ${variant.copy}\n\n`
        )
        .join("");

      await navigator.clipboard.writeText(textContent);
      toastify("success", "Copy variations copied to clipboard!");
    } catch (err) {
      toastify("error", "Failed to copy variations to clipboard");
    }
  };
  const handleDeleteCopyVariations = async () => {
    let warningMessage = "";

    if (variationsAdCopy.length === 1) {
      warningMessage = "Cannot delete last copy variation";
    } else if (selectedCopyVariations.length === variationsAdCopy.length) {
      warningMessage = "Cannot delete all copy variations";
    } else if (
      selectedCopyVariations.some((index) => !variationsAdCopy[index]._id)
    ) {
      warningMessage = "Cannot delete copy variation that is being used";
    }

    if (warningMessage) {
      setAdCopyWarningMessage(warningMessage);
      setAdCopyWarning(true);
      return;
    }

    // Remove selected variations from the array
    const updatedVariations = variationsAdCopy.filter(
      (_, index) => !selectedCopyVariations.includes(index)
    );

    const updatedVariationIds = variationsAdCopy
      .filter((_, index) => selectedCopyVariations.includes(index))
      .map((item) => item._id);

    const isDeletedSelected = updatedVariationIds.includes(
      ad.selectedCopyVariationId
    );

    const token = localStorage.getItem("token");
    try {
      await axios.post(
        `${process.env.REACT_APP_API}ads/delete-ad-copy-variations`,
        {
          adId: id,
          adCopyVariationIds: updatedVariationIds,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the request header
          },
        }
      );
      if (isDeletedSelected) {
        handleSaveChanges(
          true,
          "",
          updatedVariations[updatedVariations?.length - 1]?.copy,
          updatedVariations[updatedVariations?.length - 1]?.headline,
          updatedVariations[updatedVariations?.length - 1]?._id
        );
      } else {
        fetchAdDetail();
      }
      setSelectedCopyVariations([]);
      setIsCopyDeleteMode(false);
      toastify("success", "Selected variations deleted successfully!");
    } catch (error) {
      toastify("error", "Unable to delete variations");

      console.error(error);
    }
  };

  const handleDownload = async () => {
    setIsDownloading(true);
    const updatedVariations = variationsAdCopy.filter((_, index) =>
      selectedCopyVariations.includes(index)
    );
    const zip = new JSZip();

    // For each object in the array, create a separate txt file
    updatedVariations.forEach((item, index) => {

      const fileContent = `Headline: ${item.headline}\nDescription: ${item.description}\nAdCopy: ${item.copy}`;
      zip.file(`variation_${index + 1}.txt`, fileContent);
    });

    // Generate the zip file and trigger download
    const content = await zip.generateAsync({ type: "blob" });
    saveAs(content, "variations.zip");
    setIsDownloading(false);
  };

  const handleDownloadAll = () => {
    const variants = ad.variants;
    variants.forEach((variant, index) => {
      const link = document.createElement("a");
      link.href = variant || "/placeholder.svg";
      link.download = `${ad.title.replace(/\s+/g, "_")}_variant_${index + 1
        }.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
    setShowDropdown(false);
  };

  const handleCopyTo = () => {
    alert("Move to bucket functionality");
    setShowDropdown(false);
  };

  const handleEditableCopy = async (editCopy) => {
    setVariationAdCopy((prev) => {
      if (prev.length === 0) return prev; // safety: no items

      // ✅ fallback to last index if not a valid number
      const targetIndex =
        typeof selectedCopyVariation === "number" &&
          !isNaN(selectedCopyVariation)
          ? selectedCopyVariation
          : prev.length - 1;

      return prev.map((item, index) =>
        index === targetIndex ? { ...item, copy: editCopy } : item
      );
    });

    setStatusCopyContent(true);
    setEditableCopy(editCopy);
  };
  const handleEditableHeadline = async (editHeadline) => {
    setVariationAdCopy((prev) => {
      if (prev.length === 0) return prev; // safety: no items

      // ✅ fallback to last index if not a valid number
      const targetIndex =
        typeof selectedCopyVariation === "number" &&
          !isNaN(selectedCopyVariation)
          ? selectedCopyVariation
          : prev.length - 1;

      return prev.map((item, index) =>
        index === targetIndex ? { ...item, headline: editHeadline } : item
      );
    });

    setStatusCopyContent(true);
    setEditableHeadline(editHeadline);
  };
  const handleDelete = async () => {
    setShowDropdown(!showDropdown);
    setIsOpenDelete(true);
  };
  const handleDeleteAction = async () => {
    setIsDeleting(true);
    try {
      await services.deleteMultipleAds([id]);
      setTimeout(() => {
        navigate("/app/ads");
      }, 1000);
    } catch (error) {
      console.error(error);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleDeleteVariant = async () => {
    setIsDeletingVariants(true);
    if (
      ad.variants.length <= 1 ||
      selectedVariations.length === ad.variants.length
    ) {
      setShowConfirmModal(true);
      setIsDeletingVariants(false);
      return;
    }
    const selectedUrls = selectedVariations
      .map((i) => ad.variants[i]?.url)
      .filter(Boolean);

    const token = localStorage.getItem("token");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}ads/delete-ad-image-variation`,
        {
          imageUrls: selectedUrls,
          adId: id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the request header
          },
        }
      );
      toastify("success", response.data.message);

      const updatedAd = await fetchAdDetail();

      // Remove deleted images locally (in case fetchAdDetail isn’t instant)
      const remainingVariants = updatedAd?.variants || [];

      let newSelectedImage = null;
      let newSelectedIndex = 0;

      newSelectedImage = remainingVariants[0].url;
      newSelectedIndex = 0;

      setIsDeleteMode(false);
      setSelectedVariations([]);
      setSelectedVariant(newSelectedIndex);
      setSelectedImageVariation(newSelectedImage);
      handleSaveChanges(false, newSelectedImage);
      setIsDeletingVariants(false);
    } catch (err) {
      setError("Failed to save brand. Please try again.");
      toastify("error", err.response.data.message);
      console.error(err);
    }
  };
  const handleBackToAds = () => {
    const returnUrl = location.state?.returnUrl;
    const returnScreen = location.state?.screen;
    if (hasUnsavedChanges) {
      setIsOpen(true);
    } else if (returnUrl) {
      // Navigate back to CMO marketing page at the Creatives screen
      navigate(returnUrl, { state: { screen: returnScreen } });
    } else {
      navigate("/app/ads");
    }
  };


  const handleNotFoundBack = () => {
    const returnUrl = location.state?.returnUrl;
    const returnScreen = location.state?.screen;

    if (returnUrl) {
      navigate(returnUrl, { state: { screen: returnScreen } });
    } else {
      navigate("/app/ads");
    }
  };
  const downloadImagesAsZip = async () => {
    setIsDownloading(true);
    if (!ad?.variants?.length) {
      toastify("error", "No images available to download");
      return;
    }

    const zip = new JSZip();
    const folder = zip.folder("images");

    const indexesToDownload =
      selectedVariations.length > 0
        ? selectedVariations
        : ad.variants.map((_, i) => i);

    try {
      await Promise.all(
        indexesToDownload.map(async (index) => {
          const variant = ad.variants[index]?.url;
          if (!variant) return;

          const response = await fetch(variant, {
            method: "GET",
            mode: "cors", // Explicitly set CORS mode
            headers: {
              Accept: "image/*",
              "Cache-Control": "no-cache", // Prevent caching issues
            },
          });

          if (!response.ok) {
            throw new Error(`Failed to fetch ${variant}: ${response.status}`);
          }

          const blob = await response.blob();
          const fileName = variant.split("/").pop() || `image-${index + 1}.jpg`;
          folder.file(fileName, blob);
        })
      );

      const content = await zip.generateAsync({ type: "blob" });
      saveAs(content, "images.zip");
      setSelectedVariant("");
      setSelectedVariations([]);
      toastify("success", "Images downloaded successfully!");
      setIsDownloading(false);
    } catch (error) {
      setIsDownloading(false);
      console.error("Error downloading images:", error);
      toastify("error", "Failed to download. No zip created.");
    }
  };
  // Step 1: merge ad + variationsAdCopyData (priority to variationsAdCopyData)
  const mergedData = {
    ...ad,
    ...variationsAdCopyData, // overrides ad if fields exist
  };

  // Step 2: decide what text to show
  const sourceHeadline = editableHeadline || mergedData.headline;
  const sourceCopy = editableCopy || mergedData.copy;

  // Step 3: build combined text
  const combinedText = `${sourceCopy}`;

  const isLongText = combinedText.length > 100;
  const displayText = isTextExpanded
    ? combinedText
    : isLongText
      ? combinedText.substring(0, 100).trimEnd() + "..."
      : combinedText;

  const setSelectedVariation = (url, index) => {
    setSelectedImageVariation(url);
    setSelectedVariant(index);
    const img = new Image();
    img.src = url;

    img.onload = () => {
      const w = img.naturalWidth;
      const h = img.naturalHeight;
      setSelectedAspectRatio(`${w}x${h}`);
      handleSaveChanges(false, url);
    };

    img.onerror = () => {
      console.error("Failed to load image:", url);
    };
  };

  useState(false);







  useState(false);

  // Handle drag and drop






  return (
    <>
      {isLoading ? (
        <div className="App-loading">
          <div className="App-logo" title="Zimzee" />
        </div>
      ) : isAdNotFound ? (
        <div className="min-h-[calc(100vh-64px)] bg-gray-100 dark:bg-[#0A0A0A] flex items-center justify-center px-6 py-12">
          <div className="w-full max-w-md rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-[#111111] p-8 text-center shadow-sm">
            <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-orange-50 text-orange-600 dark:bg-orange-500/10 dark:text-orange-400">
              <ImageIcon className="h-7 w-7" aria-hidden="true" />
            </div>
            <h1 className="text-xl font-semibold text-gray-900 dark:text-white">
              Ad not found
            </h1>
            <p className="mt-2 text-sm leading-6 text-gray-600 dark:text-gray-400">
              This ad may have been deleted or is no longer available.
            </p>
            <button
              type="button"
              onClick={handleNotFoundBack}
              className="mt-6 inline-flex items-center justify-center rounded-lg bg-[#ff6600] px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-[#e65c00] focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 dark:focus:ring-offset-[#111111]"
            >
              Back to ads
            </button>
          </div>
        </div>
      ) : (
        <div className="responsive-page responsive-page--ad-detail bg-gray-100 dark:bg-[#0A0A0A]">
          {/* Header */}
          <div className="bg-white dark:bg-[#0A0A0A] border-b border-gray-200 dark:border-gray-700 px-6 pb-3">
            <div className="flex items-center justify-between">
              <button
                onClick={handleBackToAds}
                className="text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-[#fff] flex items-center gap-2"
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                  />
                </svg>
                Back to ads
              </button>

              <div className="flex items-center gap-3">
                {/* <button
                  onClick={saveEditedChanges}
                  disabled={!hasUnsavedChanges}
                  style={{
                    backgroundColor: !hasUnsavedChanges ? "#cdd1d6" : "#ff6600",
                  }}
                  className="text-white hover:opacity-90 px-4 py-2 rounded-lg flex items-center gap-2"
                >
                  <Save className="w-4 h-4" />
                  Save Changes
                </button> */}
                <button
                  onClick={saveEditedChanges}
                  disabled={!hasUnsavedChanges}
                  className={`px-4 py-2 rounded-lg flex items-center gap-2 text-white transition-opacity duration-200
    ${hasUnsavedChanges
                      ? "bg-[#ff6600] hover:opacity-90"
                      : "bg-gray-300 dark:bg-[#1a1a1a] cursor-not-allowed opacity-70"
                    }`}
                >
                  <Save className="w-4 h-4" />
                  Save Changes
                </button>

                <div className="relative" ref={dropdownRef}>
                  <button
                    className="h-10 w-10 border border-gray-300 dark:border-gray-600 rounded-lg cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800 flex items-center justify-center"
                    onClick={() => setShowDropdown(!showDropdown)}
                  >
                    <svg
                      className="w-4 h-4 text-gray-600 dark:text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
                      />
                    </svg>
                  </button>

                  {showDropdown && (
                    <div className="absolute right-0 top-12 w-56 bg-white dark:bg-[#0A0A0A] border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg z-50 py-1">
                      <button
                        className="w-full px-4 py-2 text-left hover:bg-gray-50 dark:hover:bg-gray-800 flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300 hidden"
                        onClick={handleDownloadAll}
                      >
                        <svg
                          className="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                          />
                        </svg>
                        Download all variations
                      </button>
                      <button
                        className="w-full px-4 py-2 text-left hover:bg-gray-50 dark:hover:bg-gray-800 flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300"
                        onClick={handleCopyTo}
                      >
                        <svg
                          className="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2z"
                          />
                        </svg>
                        Copy to a bucket
                      </button>
                      <button
                        className="w-full px-4 py-2 text-left hover:bg-gray-50 dark:hover:bg-gray-800 flex items-center gap-2 text-red-600 dark:text-red-400 text-sm"
                        onClick={handleDelete}
                      >
                        <svg
                          className="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                          />
                        </svg>
                        Delete All
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {(isDownloading || isDeletingVariants) && (
            <div className="flex items-center text-sm text-orange-600 dark:text-orange-400 bg-orange-50 dark:bg-orange-900/20 p-2 rounded">
              <Loader className="mr-2 h-4 w-4 animate-spin" />
              {isDownloading
                ? "Downloading Variations..."
                : "Deleting Variations..."}
            </div>
          )}
          <div className="ad-detail-layout flex gap-8 p-6 max-w-7xl mx-auto">
            {/* Left Side - Ad Preview */}
            <div className="ad-detail-preview-column flex-1">
              {/* Facebook-style sponsored card */}
              <div className="ad-detail-preview-shell bg-white dark:bg-[#0A0A0A] rounded-lg py-8 px-12 shadow-sm w-full">
                {/* Post header */}
                <div className="ad-detail-preview-card bg-white dark:bg-[#0A0A0A] rounded-2xl border border-gray-300 dark:border-gray-700 shadow-lg w-[500px] mx-auto overflow-hidden">
                  <div className="flex items-center justify-between p-4 pb-3">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-gradient-to-br from-orange-500 to-red-500 flex items-center justify-center">
                        <span className="text-white font-bold text-sm">
                          {ad.brand?.charAt(0).toUpperCase()}
                        </span>
                      </div>
                      <div>
                        <div className="font-semibold text-gray-900 dark:text-[#fff] text-sm">
                          {ad?.brand}
                        </div>
                        <div className="text-xs text-gray-500 dark:text-gray-400 flex items-center gap-1">
                          Sponsored
                          <svg
                            className="w-3 h-3"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="text-gray-400 dark:text-gray-500">
                        <svg
                          className="w-5 h-5"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
                        </svg>
                      </div>
                      <div className="text-gray-400 dark:text-gray-500">
                        <svg
                          className="w-5 h-5"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                        </svg>
                      </div>
                    </div>
                  </div>
                  {/* Post content */}
                  <div className="px-4 pb-3">
                    <div className="text-gray-900 dark:text-[#fff] text-sm leading-relaxed">
                      <span className="whitespace-pre-line">{displayText}</span>

                      {isLongText && (
                        <button
                          type="button"
                          onClick={() => setIsTextExpanded(!isTextExpanded)}
                          className="text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 ml-2 font-medium"
                        >
                          {isTextExpanded ? "See less" : "See more"}
                        </button>
                      )}
                    </div>
                  </div>
                  {/* Ad creative (image block) */}
                  <div className="flex items-center justify-center">
                    {hasImage ? (
                      <img
                        width="1024"
                        height="1024"
                        alt="Ad Preview"
                        loading="lazy"
                        className="z-1 w-full h-auto block"
                        draggable="false"
                        src={selectedImageVariation || ad.imageUrl}
                      />
                    ) : null}
                    {/* Hidden decorative elements */}
                    <div className="absolute inset-0 p-8 flex flex-col justify-center hidden">
                      <div className="text-white font-bold text-4xl leading-tight mb-8 hidden">
                        {Array.isArray(ad.visualKeywords) &&
                          ad.visualKeywords.length > 0 && (
                            <div>
                              {ad.visualKeywords.map((keyword, i) => (
                                <div key={i}>{keyword}</div>
                              ))}
                            </div>
                          )}
                      </div>
                      {/* Phone mockup in bottom right */}
                      <div className="absolute bottom-6 right-6 hidden">
                        <div className="relative">
                          <div className="bg-white rounded-3xl p-2 shadow-lg transform rotate-12">
                            <div className="w-24 h-44 bg-gray-100 rounded-2xl overflow-hidden relative">
                              <div className="absolute inset-2 bg-white rounded-xl">
                                <div className="p-2 space-y-2">
                                  <div className="flex items-center gap-2">
                                    <div className="w-6 h-6 bg-orange-500 rounded-full"></div>
                                    <div className="flex-1 h-2 bg-gray-200 rounded"></div>
                                  </div>
                                  <div className="h-16 bg-gradient-to-br from-orange-100 to-orange-200 rounded"></div>
                                  <div className="space-y-1">
                                    <div className="h-1.5 bg-gray-200 rounded"></div>
                                    <div className="h-1.5 bg-gray-200 rounded w-3/4"></div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="absolute -bottom-2 -left-2 w-16 h-12 bg-orange-300 rounded-full transform -rotate-12 opacity-80"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Website link preview */}
                  <div className="border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-transparent p-4 pr-6">
                    <div className="flex items-start justify-between gap-3">
                      <div className="flex-1 min-w-0">
                        <div className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wide font-medium">
                          {ad?.brandId?.url
                            ? new URL(ad?.brandId.url).hostname
                            : ""}
                        </div>
                        <div className="font-semibold text-gray-900 dark:text-[#fff] text-base mt-1">
                          {sourceHeadline}
                        </div>
                        <div className="text-sm text-gray-600 dark:text-gray-400 mt-1 truncate">
                          {variationsAdCopyData?.description
                            ? variationsAdCopyData?.description
                            : ad?.description}
                          ...
                        </div>
                      </div>

                      <a
                        href={ad?.brandId?.url}
                        target="_blank"
                        className="bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 text-gray-900 dark:text-[#fff] text-sm px-3 py-2 rounded-lg font-medium border border-gray-200 dark:border-gray-600 shadow-sm shrink-0"
                        rel="noopener noreferrer">
                        Learn more
                      </a>
                    </div>
                  </div>
                  {/* Engagement stats */}
                  <div className="px-4 py-3 border-t border-gray-200 dark:border-gray-700 hidden">
                    <div className="flex items-center justify-between text-sm text-gray-500 dark:text-gray-400">
                      <div className="flex items-center gap-2">
                        <div className="flex items-center gap-1">
                          <div className="w-5 h-5 bg-blue-500 rounded-full flex items-center justify-center">
                            <svg
                              className="w-3 h-3 text-white"
                              viewBox="0 0 24 24"
                              fill="currentColor"
                            >
                              <path d="M14,9V5a3,3 0 0,0 -6,0v4H6V5a5,5 0 0,1 10,0v4h1a2,2 0 0,1 2,2v6a2,2 0 0,1 -2,2H7a2,2 0 0,1 -2,-2V11a2,2 0 0,1 2,-2H14M12,17a2,2 0 0,0 2,-2a2,2 0 0,0 -2,-2a2,2 0 0,0 -2,2a2,2 0 0,0 2,2Z" />
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center gap-4 text-sm">
                        {/* Engagement stats would go here */}
                      </div>
                    </div>
                  </div>
                  {/* Action buttons */}
                  <div className="border-t border-gray-200 dark:border-gray-700 px-4 py-2 hidden">
                    <div className="flex items-center justify-between">
                      <button className="flex-1 text-gray-600 dark:text-gray-400 text-sm py-3 hover:bg-gray-100 dark:hover:bg-gray-800 flex items-center justify-center gap-2">
                        <svg
                          className="w-4 h-4"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path d="M23,10C23,8.89 22.1,8 21,8H14.68L15.64,3.43C15.66,3.33 15.67,3.22 15.67,3.11C15.67,2.7 15.5,2.32 15.23,2.05L14.17,1L7.59,7.58C7.22,7.95 7,8.45 7,9V19A2,2 0 0,0 9,21H18C18.83,21 19.54,20.5 19.84,19.78L22.86,12.73C22.95,12.5 23,12.26 23,12V10M1,21H5V9H1V21Z" />
                        </svg>
                        Like
                      </button>
                      <button className="flex-1 text-gray-600 dark:text-gray-400 text-sm py-3 hover:bg-gray-100 dark:hover:bg-gray-800 flex items-center justify-center gap-2">
                        <svg
                          className="w-4 h-4"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path d="M9,22A1,1 0 0,1 8,21V18H4A2,2 0 0,1 2,16V4C2,2.89 2.9,2 4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H13.9L10.2,21.71C10,21.9 9.75,22 9.5,22V22H9Z" />
                        </svg>
                        Comment
                      </button>
                      <button className="flex-1 text-gray-600 dark:text-gray-400 text-sm py-3 hover:bg-gray-100 dark:hover:bg-gray-800 flex items-center justify-center gap-2">
                        <svg
                          className="w-4 h-4"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path d="M21,12L14,5V9C7,10 4,15 3,20C5.5,16.5 9,14.9 14,14.9V19L21,12Z" />
                        </svg>
                        Share
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side - Controls */}
            <div className="ad-detail-controls w-96">
              <div className="p-6 bg-white dark:bg-[#0A0A0A] rounded-lg shadow border  dark:border-gray-700">
                {/* Tabs */}
                <div className="mb-6">
                  <div className="flex w-full bg-gray-100 dark:bg-transparent rounded-lg p-1">
                    {/* Image Tab */}
                    <div
                      className={`flex-1 text-center py-1 rounded-lg cursor-pointer transition-colors ${activeTab === "image"
                        ? "bg-gray-50 dark:bg-[#222222] text-gray-800 dark:text-[#fff] font-medium"
                        : "text-gray-400 dark:text-gray-500 hover:text-gray-500 dark:hover:text-gray-400"
                        }`}
                      onClick={() => setActiveTab("image")}
                    >
                      <div className="flex items-center justify-center">
                        <ImageIcon className="mr-1 w-4 h-4" />
                        <div>Image</div>
                      </div>
                    </div>

                    {/* Ad Copy Tab */}
                    <div
                      className={`flex-1 text-center py-1 rounded-lg cursor-pointer transition-colors ${activeTab === "copy"
                        ? "bg-gray-50 dark:bg-[#222222] text-gray-800 dark:text-[#fff] font-medium"
                        : "text-gray-400 dark:text-gray-500 hover:text-gray-500 dark:hover:text-gray-400"
                        }`}
                      onClick={() => setActiveTab("copy")}
                    >
                      <div className="flex items-center justify-center">
                        <PenTool className="mr-1 w-4 h-4" />
                        <div>Ad Copy</div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Tab Content */}
                {activeTab === "image" && (
                  <div className="space-y-4">
                    {/* Variations Section */}
                    <div className="space-y-3">
                      <div className="flex items-center justify-between text-sm">
                        <span className="font-medium text-gray-900 dark:text-[#fff]">
                          {ad?.variants?.length || 0} variations:
                        </span>
                        <div className="flex items-center gap-1 ">
                          <button
                            className="h-6 w-6 p-0 text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-[#fff] cursor-pointer"
                            title="Download selected"
                            disabled={selectedVariations.length === 0}
                            onClick={() => downloadImagesAsZip()}
                          >
                            <DownloadIcon
                              className={`w-4 h-4 ${selectedVariations.length > 0
                                ? "text-gray-800 dark:text-[#fff]"
                                : "text-gray-500 dark:text-gray-400"
                                } `}
                            />
                          </button>

                          <button
                            className="h-6 w-6 p-0 text-red-500 dark:text-red-400 hover:text-red-600 dark:hover:text-red-300 cursor-pointer"
                            title="Delete selected"
                            disabled={selectedVariations.length === 0}
                            onClick={() => handleDeleteVariant()}
                          >
                            <Trash2
                              className={`w-4 h-4 ${selectedVariations.length > 0
                                ? "text-red-600 dark:text-red-300"
                                : "text-red-400 dark:text-red-500"
                                } `}
                            />
                          </button>
                        </div>
                      </div>

                      {/* Variations Grid */}
                      <div className="grid grid-cols-4 gap-2 p-2">
                        {ad?.variants?.map((variant, index) => {
                          const isSelected = selectedVariations.includes(index);
                          const isPreviewed = selectedVariant === index;
                          const showCheckbox =
                            hoveredVariation === index ||
                            selectedVariations.length > 0;

                          return (
                            <div
                              key={index}
                              className="relative group"
                              onMouseEnter={() => setHoveredVariation(index)}
                              onMouseLeave={() => setHoveredVariation(null)}
                              onClick={() =>
                                !isDeleteMode && setSelectedVariant(index)
                              }
                            >
                              {showCheckbox && (
                                <input
                                  type="checkbox"
                                  checked={isSelected}
                                  onChange={(e) => {
                                    e.stopPropagation();
                                    handleVariationSelection(index);
                                  }}
                                  className="absolute top-1 left-1 z-10 w-3 h-3 rounded border-2 border-white dark:border-gray-800 accent-orange-500"
                                />
                              )}
                              <div
                                className={`aspect-square rounded-lg overflow-hidden w-full cursor-pointer hover:opacity-90 transition-all
  ${isSelected || isPreviewed
                                    ? "ring-2 ring-orange-500 border-none"
                                    : "border-2 border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600"
                                  }
  ${isDeleteMode ? "opacity-75" : ""}`}
                                onClick={() =>
                                  setSelectedVariation(variant?.url, index)
                                }
                              >
                                <img
                                  src={
                                    variant?.url ||
                                    `https://via.placeholder.com/150?text=Ad+Variant+${index + 1
                                    }`
                                  }
                                  alt={`variation ${index + 1}`}
                                  className="w-full h-full object-contain bg-gray-500"
                                />
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>

                    <ImageEditComponent
                      isOpen={true}
                      imageUrl={selectedImageVariation}
                      variantId="variant-1"
                      variantName="Variation 1"
                      fetchAdDetail={fetchAdVariations}
                      existingVariationUrls={(ad?.variants || [])
                        .map(getImageUrl)
                        .filter(Boolean)}
                      containerWidth={350}
                    />

                    {/* Reference Section */}
                    {referenceCard && (
                      <div className="mt-6">
                        <div className="text-sm font-medium text-gray-900 dark:text-[#fff] mb-3">
                          Reference:
                        </div>
                        <div className="space-y-2">
                          <div
                            className="w-full p-3 text-left border border-gray-200 dark:border-gray-700 rounded-lg hover:border-gray-300 dark:hover:border-gray-600 transition-colors cursor-pointer"
                            onClick={() =>
                              setShowOriginalReference((prev) => !prev)
                            }
                          >
                            <div className="flex items-center justify-between">
                              <div>
                                <div className="text-sm font-medium text-gray-900 dark:text-[#fff]">
                                  Original Ad Reference
                                </div>
                                <div className="text-xs text-gray-600 dark:text-gray-400 mt-1">
                                  {showOriginalReference
                                    ? "Click to hide reference"
                                    : "Click to view original ad used for inspiration"}
                                </div>
                              </div>
                              <svg
                                className={`w-4 h-4 text-gray-400 dark:text-gray-500 transition-transform ${showOriginalReference ? "rotate-180" : ""
                                  }`}
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M19 9l-7 7-7-7"
                                />
                              </svg>
                            </div>
                          </div>
                          {showOriginalReference && (
                            <div className="w-full p-4 border border-blue-200 dark:border-blue-800 rounded-lg bg-blue-50 dark:bg-blue-900/20">
                              <div
                                className="mb-3 bg-gray-100 dark:bg-gray-800 rounded-lg overflow-hidden shadow-md flex justify-center"
                              >
                                <img
                                  src={referenceCard?.content?.imageUrl[0]?.url}
                                  alt="Original Ad Reference"
                                  className="w-full h-auto object-contain max-h-[500px]"
                                />
                              </div>
                              <div className="text-xs text-gray-700 dark:text-gray-300 leading-relaxed bg-white dark:bg-gray-800 p-3 rounded border border-gray-200 dark:border-gray-700">
                                <RichDescription
                                  descriptionHtml={referenceCard?.aiData?.descriptionHtml || referenceCard?.content?.extractedData?.descriptionHtml}
                                  description={referenceCard?.aiData?.description || referenceCard?.adData?.description || referenceCard?.content?.extractedData?.description || extractReferenceText(referenceCard?.content?.html)}
                                  descriptionLineHeight={referenceCard?.aiData?.descriptionLineHeight || referenceCard?.content?.extractedData?.descriptionLineHeight}
                                  maxWords={20}
                                  expanded={isReferenceExpanded}
                                  onToggle={setIsReferenceExpanded}
                                  toggleClassName="text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 ml-2 font-medium"
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                )}
                {activeTab === "copy" && (
                  <div>
                    {/* Editable Headline and Copy */}
                    <div className="space-y-4 mb-4">
                      <div>
                        <label
                          htmlFor="headline"
                          className="text-sm font-medium text-gray-900 dark:text-[#fff]"
                        >
                          Ad Headline
                        </label>
                        <textarea
                          id="headline"
                          value={editableHeadline}
                          onChange={(e) => {
                            handleEditableHeadline(e.target.value);
                            setShowUnsavedChangesForGeneration(true);
                          }}
                          rows={1}
                          className="text-sm resize-y mt-1 border border-gray-300 dark:border-gray-900 rounded px-3 py-2 w-full focus:outline-none focus:ring-1 focus:ring-orange-500 focus:border-orange-500 bg-white dark:bg-[#222222] text-gray-900 dark:text-[#fff]"
                          placeholder="Enter your ad headline..."
                          style={{
                            backgroundClip: "padding-box",
                            backgroundImage: "none",
                            backgroundAttachment: "local",
                            // Additional styles for resizer
                            scrollbarWidth: "none", // Firefox
                            msOverflowStyle: "none", // IE/Edge
                          }}
                        />
                      </div>
                      <div>
                        <label
                          htmlFor="copy"
                          className="text-sm font-medium text-gray-900 dark:text-[#fff]"
                        >
                          Ad Copy
                        </label>
                        <textarea
                          id="copy"
                          value={editableCopy}
                          onChange={(e) => {
                            handleEditableCopy(e.target.value);
                            setShowUnsavedChangesForGeneration(true);
                          }}
                          className="text-sm min-h-[120px] resize-y mt-1 border border-gray-300 dark:border-gray-900 rounded px-3 py-2 w-full focus:outline-none focus:ring-1 focus:ring-orange-500 focus:border-orange-500 bg-white dark:bg-[#222222] text-gray-900 dark:text-[#fff]"
                          placeholder="Enter your ad copy..."
                          rows={1}
                          style={{
                            backgroundClip: "padding-box",
                            backgroundImage: "none",
                            backgroundAttachment: "local",
                            // Additional styles for resizer
                            scrollbarWidth: "none", // Firefox
                            msOverflowStyle: "none", // IE/Edge
                          }}
                        />
                      </div>
                      <div>
                        <div className="flex items-center flex-start">
                          <label
                            htmlFor="copy-variation-ideas"
                            className="text-sm font-medium text-gray-900 dark:text-[#fff]"
                          >
                            New copy ideas (recommended)
                          </label>
                          {/* <button
                            className={`h-6 px-2 text-xs ${
                              adCopyPrompt
                                ? "text-gray-600 dark:text-gray-400"
                                : "text-gray-400 dark:text-gray-500"
                            }  cursor-pointer flex items-center gap-1`}
                            onClick={() => copyPrompt(adCopyPrompt)}
                            title="Copy ideas for variation"
                            disabled={!adCopyPrompt}
                          >
                            <CopyIcon className="w-4 h-4" />
                            Copy
                          </button> */}
                        </div>
                        <textarea
                          id="copy-variation-ideas"
                          value={adCopyPrompt}
                          onChange={(e) => setAdCopyPrompt(e.target.value)}
                          placeholder="e.g., add a stronger hook, make it more conversational, focus on benefits, or adjust the tone…"
                          className="text-sm mt-1 border border-gray-300 dark:border-gray-900 rounded px-3 py-2 w-full resize-y focus:outline-none focus:ring-1 focus:ring-orange-500 focus:border-orange-500 bg-white dark:bg-[#222222] text-gray-900 dark:text-[#fff]"
                          rows={3}
                          style={{
                            backgroundClip: "padding-box",
                            backgroundImage: "none",
                            backgroundAttachment: "local",
                            // Additional styles for resizer
                            scrollbarWidth: "none", // Firefox
                            msOverflowStyle: "none", // IE/Edge
                          }}
                        />
                      </div>
                    </div>
                    {/* Generate Variations Button */}
                    <div className="flex gap-2 mb-4">
                      <button
                        onClick={handleGenerateCopyVariants}
                        disabled={isGeneratingVariants}
                        className={`w-full font-medium py-2 rounded-lg shadow-sm transition-all flex items-center justify-center gap-2
    ${isGeneratingVariants
                            ? "cursor-not-allowed bg-gray-400 text-gray-200 shadow-none"
                            : "cursor-pointer bg-orange-500 hover:bg-orange-600 text-white hover:shadow-md"
                          }
  `}
                      >
                        {isGeneratingVariants && (
                          <svg
                            className="w-4 h-4 animate-spin"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M4 4v5h.582M20 20v-5h-.581M5 19A9 9 0 1119 5A9 9 0 015 19z"
                            />
                          </svg>
                        )}
                        Generate Variations
                      </button>
                    </div>
                    {hasUnsavedChanges && showUnsavedChangesForGeneration && (
                      <div className="text-sm text-orange-600 dark:text-orange-400 bg-orange-50 dark:bg-orange-900/20 p-2 rounded">
                        You have unsaved changes
                      </div>
                    )}
                    {/* Copy Variations */}
                    <div className="mt-6 space-y-4">
                      {/* Copy Variations Controls */}
                      {variationsAdCopy?.length > 0 && (
                        <div className="flex items-center justify-between text-sm">
                          <span className="font-medium text-gray-900 dark:text-[#fff]">
                            {variationsAdCopy?.length || 0} copy variations
                          </span>
                          <div className="flex items-center gap-1">
                            <button
                              className="h-6 w-6 p-0 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-[#fff]"
                              title="Download selected"
                              disabled={selectedCopyVariations.length === 0}
                              onClick={handleDownload}
                            >
                              <DownloadIcon
                                className={`w-4 h-4 ${selectedCopyVariations.length > 0
                                  ? "text-gray-700 dark:text-[#fff]"
                                  : "text-gray-500 dark:text-gray-400"
                                  } `}
                              />
                            </button>
                            <button
                              className="h-6 w-6 p-0 text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-[#fff]"
                              title="Copy selected"
                              disabled={selectedCopyVariations.length === 0}
                              onClick={handleCopyCopyVariations}
                            >
                              <CopyIcon
                                className={`w-4 h-4 ${selectedCopyVariations.length > 0
                                  ? "text-gray-700 dark:text-[#fff]"
                                  : "text-gray-500 dark:text-gray-400"
                                  } `}
                              />
                            </button>
                            <button
                              className="h-6 w-6 p-0 text-red-500 dark:text-red-400 hover:text-red-800 dark:hover:text-red-300"
                              title="Delete selected"
                              disabled={selectedCopyVariations.length === 0}
                              onClick={handleDeleteCopyVariations}
                            >
                              <Trash2
                                className={`w-4 h-4 ${selectedCopyVariations.length > 0
                                  ? "text-red-600 dark:text-red-300"
                                  : "text-red-400 dark:text-red-500"
                                  } `}
                              />
                            </button>
                          </div>
                        </div>
                      )}

                      {/* Copy Variations List */}
                      <div className="space-y-2 max-h-96 overflow-y-auto pr-2">
                        {variationsAdCopy?.length > 0 &&
                          variationsAdCopy
                            ?.map((variantAdCopy, originalIndex) => {
                              const isSelected =
                                selectedCopyVariations.includes(originalIndex);
                              const isPreviewed =
                                selectedCopyVariation === originalIndex;
                              const showCheckbox =
                                hoveredCopyVariation === originalIndex ||
                                selectedCopyVariations.length > 0;

                              return (
                                <div
                                  key={variantAdCopy?._id ?? originalIndex}
                                  className="relative group"
                                  onMouseEnter={() =>
                                    setHoveredCopyVariation(originalIndex)
                                  }
                                  onMouseLeave={() =>
                                    setHoveredCopyVariation(null)
                                  }
                                >
                                  {showCheckbox && (
                                    <input
                                      type="checkbox"
                                      checked={isSelected}
                                      onChange={(e) => {
                                        e.stopPropagation();
                                        handleCopyVariationSelection(
                                          originalIndex
                                        );
                                      }}
                                      className="absolute top-2 left-2 z-10 w-4 h-4 rounded border-2 border-white dark:border-gray-800 accent-orange-500"
                                    />
                                  )}

                                  <div
                                    onClick={() => {
                                      if (!isCopyDeleteMode) {
                                        handleSelectedCopyVariation(
                                          originalIndex,
                                          variantAdCopy?._id
                                        );
                                      }
                                    }}
                                    className={`pt-6 border-2 rounded-xl p-4 transition-all bg-white dark:bg-[#222222] w-full text-left
              ${isPreviewed
                                        ? "border-orange-500"
                                        : "border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-900"
                                      }
              ${isCopyDeleteMode
                                        ? "opacity-50 cursor-not-allowed"
                                        : "cursor-pointer"
                                      }
            `}
                                  >
                                    <div
                                      className={`space-y-2 ${selectedVariations.length > 0
                                        ? "pl-8"
                                        : ""
                                        }`}
                                    >
                                      <h3 className="font-semibold text-gray-900 dark:text-[#fff] text-base">
                                        {variantAdCopy?.headline}
                                      </h3>
                                      <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
                                        {truncateWords(
                                          variantAdCopy?.copy ?? "",
                                          20
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                            .reverse()}
                      </div>
                    </div>

                    {/* Reference Section */}
                    {referenceCard && (
                      <div className="mt-6">
                        <div className="text-sm font-medium text-gray-900 dark:text-[#fff] mb-3">
                          Reference:
                        </div>
                        <div className="space-y-2">
                          <div
                            className="w-full p-3 text-left border border-gray-200 dark:border-gray-700 rounded-lg hover:border-gray-300 dark:hover:border-gray-600 transition-colors cursor-pointer"
                            onClick={() =>
                              setShowOriginalReference((prev) => !prev)
                            }
                          >
                            <div className="flex items-center justify-between">
                              <div>
                                <div className="text-sm font-medium text-gray-900 dark:text-[#fff]">
                                  Original Ad Reference
                                </div>
                                <div className="text-xs text-gray-600 dark:text-gray-400 mt-1">
                                  {showOriginalReference
                                    ? "Click to hide reference"
                                    : "Click to view original ad used for inspiration"}
                                </div>
                              </div>
                              <svg
                                className={`w-4 h-4 text-gray-400 dark:text-gray-500 transition-transform ${showOriginalReference ? "rotate-180" : ""
                                  }`}
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M19 9l-7 7-7-7"
                                />
                              </svg>
                            </div>
                          </div>
                          {showOriginalReference && (
                            <div className="w-full p-4 border border-blue-200 dark:border-blue-800 rounded-lg bg-blue-50 dark:bg-blue-900/20">
                              <div
                                className="mb-3 bg-gray-100 dark:bg-gray-800 rounded-lg overflow-hidden shadow-md flex justify-center"
                              >
                                <img
                                  src={referenceCard?.content?.imageUrl[0]?.url}
                                  alt="Original Ad Reference"
                                  className="w-full h-auto object-contain max-h-[500px]"
                                />
                              </div>
                              <div className="text-xs text-gray-700 dark:text-gray-300 leading-relaxed bg-white dark:bg-gray-800 p-3 rounded border border-gray-200 dark:border-gray-700">
                                <RichDescription
                                  descriptionHtml={referenceCard?.aiData?.descriptionHtml || referenceCard?.content?.extractedData?.descriptionHtml}
                                  description={referenceCard?.aiData?.description || referenceCard?.adData?.description || referenceCard?.content?.extractedData?.description || extractReferenceText(referenceCard?.content?.html)}
                                  descriptionLineHeight={referenceCard?.aiData?.descriptionLineHeight || referenceCard?.content?.extractedData?.descriptionLineHeight}
                                  maxWords={20}
                                  expanded={isReferenceExpanded}
                                  onToggle={setIsReferenceExpanded}
                                  toggleClassName="text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 ml-2 font-medium"
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                )}
                {/* Size indicator at the bottom */}
                <div className="mt-6 pt-4 border-t border-gray-200 dark:border-gray-700 hidden">
                  <div className="flex items-center gap-2 px-3 py-2 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg">
                    {(ad.size === "1024x1024" || ad.size === "1:1") ? (
                      <svg
                        width="10"
                        height="10"
                        viewBox="0 0 10 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="mr-1"
                      >
                        <rect
                          x="0.5"
                          y="0.5"
                          width="9"
                          height="9"
                          rx="1"
                          stroke="currentColor"
                          fill="none"
                        />
                      </svg>
                    ) : ad.size === "1024x1536" ? (
                      <svg
                        width="6"
                        height="12"
                        viewBox="0 0 6 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="mr-1"
                      >
                        <rect
                          x="0.5"
                          y="0.5"
                          width="5"
                          height="11"
                          rx="1"
                          stroke="currentColor"
                          fill="none"
                        />
                      </svg>
                    ) : (
                      <svg
                        width="12"
                        height="8"
                        viewBox="0 0 16 9"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="mr-1"
                      >
                        <rect
                          x="0.5"
                          y="0.5"
                          width="15"
                          height="8"
                          rx="1"
                          stroke="currentColor"
                          fill="none"
                        />
                      </svg>
                    )}
                    <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
                      {(ad.size === "1024x1024" || ad.size === "1:1")
                        ? "Square (1:1)"
                        : ad.size === "1024x1536"
                          ? "Portrait (9:16)"
                          : "Landscape (16:9)"}
                    </span>
                  </div>
                </div>
              </div>
              <p className="mt-4 rounded-xl border border-gray-200/80 bg-gray-100/70 px-4 py-3 text-left text-[13px] leading-5 text-gray-600 dark:border-gray-800 dark:bg-white/[0.04] dark:text-gray-400">
                <span className="font-medium text-gray-700 dark:text-gray-300">AI can make mistakes.</span>{" "}
                Review your content before publishing. Claims, personal experiences, and testimonials must be genuine and accurate.
              </p>
            </div>
            {/* Confirm Modals */}
            <ConfirmModal
              isOpen={showConfirmModal}
              title="Alert"
              message={
                ad?.variants?.length <= 1
                  ? "Cannot delete the last variation"
                  : selectedVariations?.length === ad?.variants?.length
                    ? "Cannot delete all variations"
                    : ""
              }
              mode="alert"
              onClose={() => setShowConfirmModal(false)}
            />
            <ConfirmModal
              isOpen={adCopyWarning}
              title="Alert"
              message={adCopyWarningMessage}
              mode="alert"
              onClose={() => setAdCopyWarning(false)}
            />
            <ConfirmModal
              isOpen={isOpens}
              title="Warning"
              message="You have unsaved changes. Are you sure you want to leave this page?"
              mode="confirm"
              onClose={closeModal}
              onConfirm={() => {
                const returnUrl = location.state?.returnUrl;
                const returnScreen = location.state?.screen;
                if (returnUrl) {
                  navigate(returnUrl, { state: { screen: returnScreen } });
                } else {
                  navigate("/app/ads");
                }
              }}
            />
            <ConfirmModal
              isOpen={isOpensDelete}
              title="Delete"
              message="
                Are you sure? This will delete the original and all
                            its variations
              "
              mode="confirm"
              onClose={closeModalDelete}
              onConfirm={handleDeleteAction}
              confirmLabel={isDeleting ? <CircularLoader size={20} color="white" /> : "Yes"}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default AdDetail;
const truncateWords = (text, limit = 30, suffix = " ...") => {
  const s = typeof text === "string" ? text : String(text ?? "");
  const words = s.trim().split(/\s+/);
  if (words.length <= limit) return s;
  return words.slice(0, limit).join(" ") + suffix;
};
